import _assertThisInitialized from "/drone/src/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _classCallCheck from "/drone/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/drone/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/drone/src/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/drone/src/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/drone/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/drone/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { logger, timestampInSeconds } from '@sentry/utils';
import { DEBUG_BUILD } from '../debug-build.js';
import { spanTimeInputToSeconds, spanToJSON } from '../utils/spanUtils.js';
import { SpanRecorder } from './span.js';
import { Transaction } from './transaction.js';
var TRACING_DEFAULTS = {
  idleTimeout: 1000,
  finalTimeout: 30000,
  heartbeatInterval: 5000
};
var FINISH_REASON_TAG = 'finishReason';
var IDLE_TRANSACTION_FINISH_REASONS = ['heartbeatFailed', 'idleTimeout', 'documentHidden', 'finalTimeout', 'externalFinish', 'cancelled'];

/**
 * @inheritDoc
 */
var IdleTransactionSpanRecorder = /*#__PURE__*/function (_SpanRecorder) {
  _inherits(IdleTransactionSpanRecorder, _SpanRecorder);
  var _super = _createSuper(IdleTransactionSpanRecorder);
  function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
    var _this;
    _classCallCheck(this, IdleTransactionSpanRecorder);
    _this = _super.call(this, maxlen);
    _this._pushActivity = _pushActivity;
    _this._popActivity = _popActivity;
    _this.transactionSpanId = transactionSpanId;
    return _this;
  }

  /**
   * @inheritDoc
   */
  _createClass(IdleTransactionSpanRecorder, [{
    key: "add",
    value: function add(span) {
      var _this2 = this;
      // We should make sure we do not push and pop activities for
      // the transaction that this span recorder belongs to.
      if (span.spanContext().spanId !== this.transactionSpanId) {
        // We patch span.end() to pop an activity after setting an endTimestamp.
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var originalEnd = span.end;
        span.end = function () {
          _this2._popActivity(span.spanContext().spanId);
          for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
            rest[_key] = arguments[_key];
          }
          return originalEnd.apply(span, rest);
        };

        // We should only push new activities if the span does not have an end timestamp.
        if (spanToJSON(span).timestamp === undefined) {
          this._pushActivity(span.spanContext().spanId);
        }
      }
      _get(_getPrototypeOf(IdleTransactionSpanRecorder.prototype), "add", this).call(this, span);
    }
  }]);
  return IdleTransactionSpanRecorder;
}(SpanRecorder);
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
var IdleTransaction = /*#__PURE__*/function (_Transaction) {
  _inherits(IdleTransaction, _Transaction);
  var _super2 = _createSuper(IdleTransaction);
  // Activities store a list of active spans

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.

  // We should not use heartbeat if we finished a transaction

  // Idle timeout was canceled and we should finish the transaction with the last span end.

  /**
   * Timer that tracks Transaction idleTimeout
   */

  /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */
  function IdleTransaction(transactionContext,
  // eslint-disable-next-line deprecation/deprecation
  _idleHub) {
    var _this3;
    var _idleTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TRACING_DEFAULTS.idleTimeout;
    var _finalTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TRACING_DEFAULTS.finalTimeout;
    var _heartbeatInterval = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : TRACING_DEFAULTS.heartbeatInterval;
    var _onScope = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var delayAutoFinishUntilSignal = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    _classCallCheck(this, IdleTransaction);
    _this3 = _super2.call(this, transactionContext, _idleHub);
    _this3._idleHub = _idleHub;
    _this3._idleTimeout = _idleTimeout;
    _this3._finalTimeout = _finalTimeout;
    _this3._heartbeatInterval = _heartbeatInterval;
    _this3._onScope = _onScope;
    _this3.activities = {};
    _this3._heartbeatCounter = 0;
    _this3._finished = false;
    _this3._idleTimeoutCanceledPermanently = false;
    _this3._beforeFinishCallbacks = [];
    _this3._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];
    _this3._autoFinishAllowed = !delayAutoFinishUntilSignal;
    if (_onScope) {
      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      DEBUG_BUILD && logger.log("Setting idle transaction on scope. Span ID: ".concat(_this3.spanContext().spanId));
      // eslint-disable-next-line deprecation/deprecation
      _idleHub.getScope().setSpan(_assertThisInitialized(_this3));
    }
    if (!delayAutoFinishUntilSignal) {
      _this3._restartIdleTimeout();
    }
    setTimeout(function () {
      if (!_this3._finished) {
        _this3.setStatus('deadline_exceeded');
        _this3._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
        _this3.end();
      }
    }, _this3._finalTimeout);
    return _this3;
  }

  /** {@inheritDoc} */
  _createClass(IdleTransaction, [{
    key: "end",
    value: function end(endTimestamp) {
      var _this4 = this;
      var endTimestampInS = spanTimeInputToSeconds(endTimestamp);
      this._finished = true;
      this.activities = {};

      // eslint-disable-next-line deprecation/deprecation
      if (this.op === 'ui.action.click') {
        this.setAttribute(FINISH_REASON_TAG, this._finishReason);
      }

      // eslint-disable-next-line deprecation/deprecation
      if (this.spanRecorder) {
        DEBUG_BUILD &&
        // eslint-disable-next-line deprecation/deprecation
        logger.log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);
        var _iterator = _createForOfIteratorHelper(this._beforeFinishCallbacks),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var callback = _step.value;
            callback(this, endTimestampInS);
          }

          // eslint-disable-next-line deprecation/deprecation
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
          // If we are dealing with the transaction itself, we just return it
          if (span.spanContext().spanId === _this4.spanContext().spanId) {
            return true;
          }

          // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
          if (!spanToJSON(span).timestamp) {
            span.setStatus('cancelled');
            span.end(endTimestampInS);
            DEBUG_BUILD && logger.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
          }
          var _spanToJSON = spanToJSON(span),
            startTime = _spanToJSON.start_timestamp,
            endTime = _spanToJSON.timestamp;
          var spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;

          // Add a delta with idle timeout so that we prevent false positives
          var timeoutWithMarginOfError = (_this4._finalTimeout + _this4._idleTimeout) / 1000;
          var spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
          if (DEBUG_BUILD) {
            var stringifiedSpan = JSON.stringify(span, undefined, 2);
            if (!spanStartedBeforeTransactionFinish) {
              logger.log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
            } else if (!spanEndedBeforeFinalTimeout) {
              logger.log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
            }
          }
          return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
        });
        DEBUG_BUILD && logger.log('[Tracing] flushing IdleTransaction');
      } else {
        DEBUG_BUILD && logger.log('[Tracing] No active IdleTransaction');
      }

      // if `this._onScope` is `true`, the transaction put itself on the scope when it started
      if (this._onScope) {
        // eslint-disable-next-line deprecation/deprecation
        var scope = this._idleHub.getScope();
        // eslint-disable-next-line deprecation/deprecation
        if (scope.getTransaction() === this) {
          // eslint-disable-next-line deprecation/deprecation
          scope.setSpan(undefined);
        }
      }
      return _get(_getPrototypeOf(IdleTransaction.prototype), "end", this).call(this, endTimestamp);
    }

    /**
     * Register a callback function that gets executed before the transaction finishes.
     * Useful for cleanup or if you want to add any additional spans based on current context.
     *
     * This is exposed because users have no other way of running something before an idle transaction
     * finishes.
     */
  }, {
    key: "registerBeforeFinishCallback",
    value: function registerBeforeFinishCallback(callback) {
      this._beforeFinishCallbacks.push(callback);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "initSpanRecorder",
    value: function initSpanRecorder(maxlen) {
      var _this5 = this;
      // eslint-disable-next-line deprecation/deprecation
      if (!this.spanRecorder) {
        var pushActivity = function pushActivity(id) {
          if (_this5._finished) {
            return;
          }
          _this5._pushActivity(id);
        };
        var popActivity = function popActivity(id) {
          if (_this5._finished) {
            return;
          }
          _this5._popActivity(id);
        };

        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanContext().spanId, maxlen);

        // Start heartbeat so that transactions do not run forever.
        DEBUG_BUILD && logger.log('Starting heartbeat');
        this._pingHeartbeat();
      }
      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder.add(this);
    }

    /**
     * Cancels the existing idle timeout, if there is one.
     * @param restartOnChildSpanChange Default is `true`.
     *                                 If set to false the transaction will end
     *                                 with the last child span.
     */
  }, {
    key: "cancelIdleTimeout",
    value: function cancelIdleTimeout(endTimestamp) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          restartOnChildSpanChange: true
        },
        restartOnChildSpanChange = _ref.restartOnChildSpanChange;
      this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
      if (this._idleTimeoutID) {
        clearTimeout(this._idleTimeoutID);
        this._idleTimeoutID = undefined;
        if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
          this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
          this.end(endTimestamp);
        }
      }
    }

    /**
     * Temporary method used to externally set the transaction's `finishReason`
     *
     * ** WARNING**
     * This is for the purpose of experimentation only and will be removed in the near future, do not use!
     *
     * @internal
     *
     */
  }, {
    key: "setFinishReason",
    value: function setFinishReason(reason) {
      this._finishReason = reason;
    }

    /**
     * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
     */
  }, {
    key: "sendAutoFinishSignal",
    value: function sendAutoFinishSignal() {
      if (!this._autoFinishAllowed) {
        DEBUG_BUILD && logger.log('[Tracing] Received finish signal for idle transaction.');
        this._restartIdleTimeout();
        this._autoFinishAllowed = true;
      }
    }

    /**
     * Restarts idle timeout, if there is no running idle timeout it will start one.
     */
  }, {
    key: "_restartIdleTimeout",
    value: function _restartIdleTimeout(endTimestamp) {
      var _this6 = this;
      this.cancelIdleTimeout();
      this._idleTimeoutID = setTimeout(function () {
        if (!_this6._finished && Object.keys(_this6.activities).length === 0) {
          _this6._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
          _this6.end(endTimestamp);
        }
      }, this._idleTimeout);
    }

    /**
     * Start tracking a specific activity.
     * @param spanId The span id that represents the activity
     */
  }, {
    key: "_pushActivity",
    value: function _pushActivity(spanId) {
      this.cancelIdleTimeout(undefined, {
        restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
      });
      DEBUG_BUILD && logger.log("[Tracing] pushActivity: ".concat(spanId));
      this.activities[spanId] = true;
      DEBUG_BUILD && logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    /**
     * Remove an activity from usage
     * @param spanId The span id that represents the activity
     */
  }, {
    key: "_popActivity",
    value: function _popActivity(spanId) {
      if (this.activities[spanId]) {
        DEBUG_BUILD && logger.log("[Tracing] popActivity ".concat(spanId));
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this.activities[spanId];
        DEBUG_BUILD && logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
      }
      if (Object.keys(this.activities).length === 0) {
        var endTimestamp = timestampInSeconds();
        if (this._idleTimeoutCanceledPermanently) {
          if (this._autoFinishAllowed) {
            this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
            this.end(endTimestamp);
          }
        } else {
          // We need to add the timeout here to have the real endtimestamp of the transaction
          // Remember timestampInSeconds is in seconds, timeout is in ms
          this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
      }
    }

    /**
     * Checks when entries of this.activities are not changing for 3 beats.
     * If this occurs we finish the transaction.
     */
  }, {
    key: "_beat",
    value: function _beat() {
      // We should not be running heartbeat if the idle transaction is finished.
      if (this._finished) {
        return;
      }
      var heartbeatString = Object.keys(this.activities).join('');
      if (heartbeatString === this._prevHeartbeatString) {
        this._heartbeatCounter++;
      } else {
        this._heartbeatCounter = 1;
      }
      this._prevHeartbeatString = heartbeatString;
      if (this._heartbeatCounter >= 3) {
        if (this._autoFinishAllowed) {
          DEBUG_BUILD && logger.log('[Tracing] Transaction finished because of no change for 3 heart beats');
          this.setStatus('deadline_exceeded');
          this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
          this.end();
        }
      } else {
        this._pingHeartbeat();
      }
    }

    /**
     * Pings the heartbeat
     */
  }, {
    key: "_pingHeartbeat",
    value: function _pingHeartbeat() {
      var _this7 = this;
      DEBUG_BUILD && logger.log("pinging Heartbeat -> current counter: ".concat(this._heartbeatCounter));
      setTimeout(function () {
        _this7._beat();
      }, this._heartbeatInterval);
    }
  }]);
  return IdleTransaction;
}(Transaction);
export { IdleTransaction, IdleTransactionSpanRecorder, TRACING_DEFAULTS };